/* import { useContext } from "react";
import { MainContext } from "../context/MainContextProvider"; */
import { Box } from "@mui/material";
import SelectClientFilterMenu from "./SelectClientFilterMenu";
import SelectUsinaFilterMenu from "./SelectUsinaFilterMenu";
import SelectClusterMenu from "../../modules/dashboard/components/SelectedClusterMenu";
import { useContext } from "react";
import { MainContext } from "../context/MainContextProvider";
import SelectUsinaDashboardMenu from "../../modules/dashboard/components/SelectUsinaDashboardMenu";
import SelectClientDashboardMenu from "../../modules/dashboard/components/SelectedClientDashboardMenu";
import { useClientClusterUsinaFilterContext } from "../context/ClientClusterUsinaFilterContextProvider";
import PrimaryBaseButton from "./PrimaryBaseButton";
import { CenterScreensEnum } from "../../modules/operations/centerScreensEnum";

export const showDashboardMenus = (path: string, selectedDashboardUsinaId: string | undefined) => {
    switch (path) {
        case "/dashboard":
        case "/operations/control":
        case "/alarm/equipment-alarms-list":
        case "/service-request/list":
        case `/usinas/details/${selectedDashboardUsinaId}`:
        case "/usinas/boletim-diario":
        case "/usinas/boletim-mensal":
        case "/usinas/boletim-personalizado":
        case "/usinas/boletim-parcial":
            return true;
        default:
            return false;
    }
}

export default function SecondHeader() {
    const { bodyWidth, selectedDashboardUsina, isMobile } = useContext(MainContext);
    const { setSelectedScreen, selectedScreen } = useClientClusterUsinaFilterContext();

    const path = window.location.pathname;

    return (
        <Box sx={{ backgroundColor: "#373635", display: "flex", alignItems: "center", width: bodyWidth, minHeight: "42px", flexDirection: "row", transition: "width 0.3s", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", minHeight: "42px", flexDirection: "row" }}>
                {showDashboardMenus(path, selectedDashboardUsina?.usinaIds.id) ?
                    <>
                        <SelectClientDashboardMenu
                            textFieldSx={{
                                '& .MuiInputBase-input': {
                                    height: "15px"
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: "17px",
                                    top: "-5px"
                                }
                            }}
                        />
                        <SelectUsinaDashboardMenu
                            textFieldSx={{
                                '& .MuiInputBase-input': {
                                    height: "15px"
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: "17px", top: "-5px"
                                }
                            }}
                        />
                    </>
                    :
                    <>
                        <SelectClientFilterMenu
                            textFieldSx={{
                                '& .MuiInputBase-input': {
                                    height: "15px"
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: "17px",
                                    top: "-5px"
                                }
                            }}
                        />
                        <SelectClusterMenu
                            textFieldSx={{
                                '& .MuiInputBase-input': {
                                    height: "15px"
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: "17px",
                                    top: "-5px"
                                }
                            }} />
                        {path.includes("operations/center") &&
                            <SelectUsinaFilterMenu
                                textFieldSx={{
                                    '& .MuiInputBase-input': {
                                        height: "15px"
                                    },
                                    '& .MuiInputLabel-root': {
                                        fontSize: "17px",
                                        top: "-5px"
                                    }
                                }}
                            />
                        }
                    </>
                }
            </Box>
            {path.includes("operations/center") && (
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        columnGap: 1,
                        rowGap: 0.5,
                        alignItems: "flex-end",
                        paddingRight: "8px",
                        justifyContent: isMobile ? "center" : "flex-end",
                        maxWidth: "100%",
                    }}
                >
                    <PrimaryBaseButton
                        isActive={
                            selectedScreen === CenterScreensEnum.Operational
                        }
                        onClick={() =>
                            setSelectedScreen(CenterScreensEnum.Operational)
                        }
                        sx={{ height: "30px" }}
                        fontSize={isMobile ? "12px" : undefined}
                        title="Operacional"
                    />
                    <PrimaryBaseButton
                        isActive={
                            selectedScreen === CenterScreensEnum.Tactical
                        }
                        onClick={() =>
                            setSelectedScreen(CenterScreensEnum.Tactical)
                        }
                        sx={{ height: "30px" }}
                        fontSize={isMobile ? "12px" : undefined}
                        title="Tático"
                    />
                    <PrimaryBaseButton
                        isActive={
                            selectedScreen === CenterScreensEnum.Strategic
                        }
                        onClick={() =>
                            setSelectedScreen(CenterScreensEnum.Strategic)
                        }
                        sx={{ height: "30px" }}
                        fontSize={isMobile ? "12px" : undefined}
                        title="Estratégico"
                    />
                </Box>)}
        </Box>
    );
}